import { LazyLoad } from 'app/utils';

export const SurveyFormPage = LazyLoad(
  () => import('./index'),
  (module) => module.SurveyFormPage,
);
